import { remove_non_ascii } from "src/utils/common";
import slug from "@sindresorhus/slugify";
import CkService from "src/services/CkService";

const buildUploadUrl = ({ tmp_id, editor_type }) => {
  return `/s3/core/connector/php/connector.php?command=FileUpload&lang=vi&type=Images&currentFolder=%2F&hash=e6f15ae802bbf5fe&responseType=json&type=Images&responseType=json&id=${tmp_id}&editorType=${editor_type}`;
};

const uploadImageByUrl = ({ url, title, tmp_id, editor_type }) => {
  if(url.includes("ytimg") || url.includes("youtube")){
    url = url.replace('i.ytimg.com','img.saostar.vn/y1200/');
    url = url.replace('default','maxresdefault');
    url = url.replace('mqdefault','maxresdefault');
    url = url.replace('sddefault','maxresdefault');
    url = url.replace('hqdefault','maxresdefault');
  }else return;
  //console.log(url);
  fetch(url).then((r) => r.blob()).then(blob =>{
    //console.log();
    const formData = new FormData();
    const fileType = url.split(".").pop();
    const fileName = slug(title.toLowerCase().replace(`.${fileType}`, ""));
    const fullFileName = remove_non_ascii(`${fileName}.${fileType}`);
    const file = new File([blob], fullFileName);
    formData.append("upload", file);
    CkService.upload(
      buildUploadUrl({ tmp_id, editor_type }),
      formData
    ).then(result => {
    const uploadedFile = result.data;
    const image = encodeURI(
      `${uploadedFile.currentFolder.url}${uploadedFile.fileName}`
    );
    //console.log({image})
    return image;
    });
  })
}

export default uploadImageByUrl;
